import { FC } from 'react';
import RetryPaymentCheckoutPageContent from './RetryPaymentCheckoutPageContent';
import FormProvider from './FormProvider/FormProvider';
import PreloadContainer from './PreloadContainer';
import RetryPaymentXStateProvider from './xstate/RetryPaymentXStateProvider';
import ApiProvider from './ApiProvider';
import { PreloadContainerFormDependent } from './PreloadContainerFormDependent';
import ApiProviderFormDependent from './ApiProviderFormDependent';
import { VGSFormProviderContainer } from './VgsFormProviderContainer';

const RetryPaymentCheckoutPage: FC = () => {
  return (
    <PreloadContainer>
      {(props) => (
        <ApiProvider {...props}>
          <FormProvider>
            <PreloadContainerFormDependent>
              {(responses) => (
                <ApiProviderFormDependent {...responses}>
                  <VGSFormProviderContainer>
                    <RetryPaymentXStateProvider>
                      <RetryPaymentCheckoutPageContent />
                    </RetryPaymentXStateProvider>
                  </VGSFormProviderContainer>
                </ApiProviderFormDependent>
              )}
            </PreloadContainerFormDependent>
          </FormProvider>
        </ApiProvider>
      )}
    </PreloadContainer>
  );
};

export default RetryPaymentCheckoutPage;
